export default __webpack_public_path__ + "4efd4d0d5e73f96e94c0a6513dd28d9c.mp3";